import { Renderer } from "@unseenco/taxi";
import { isDEVMODE, viewStorage } from "../_globals";
import WknSwiper from "../modules/wkn-swiper";

export default class PageMonatery extends Renderer {
  initialLoad() {
    document.addEventListener("DOMContentLoaded", () => {
      window.addEventListener("load", () => this.onEnter());
    });
  }

  onEnter() {
    this.DOM = {
      monasteryCarouselSwiper: viewStorage.current.querySelector(
        ".MonasteryCarousel .swiper"
      ),
    };

    if (this.DOM.monasteryCarouselSwiper) {
      if (isDEVMODE) console.log("Init Monastery carousel swiper");
      this.monasteryCarouselSwiperModule = new WknSwiper(
        this.DOM.monasteryCarouselSwiper,
        { slidesPerView: 1, spaceBetween: 34 }
      );
    }
  }

  onLeaveCompleted() {
    if (this.monasteryCarouselSwiperModule) {
      this.monasteryCarouselSwiperModule.destroy();
    }
  }
}
